<ion-header *ngIf="!pageMode">
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'CREDIT.lbl.redeem_credit' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="gradient-primary-right">
  <ion-card class="ion-padding" (click)="presentAccountSetupModal()">
    <ion-item class="ion-no-padding" lines="none">
      <ion-icon class="icon-large" slot="start" src="./assets/wedding/icon/payment/setup.svg"></ion-icon>
      <ion-text>{{ 'PAYMENT.btn.setup' | translate }}</ion-text>
      <!-- <ion-button></ion-button> -->
    </ion-item>
  </ion-card>

  <ion-card class="ion-padding" (click)="sendAsGift()">
    <ion-item class="ion-no-padding" lines="none">
      <ion-icon class="icon-large" slot="start" src="./assets/wedding/icon/payment/gift.svg"></ion-icon>
      <ion-text>{{ 'PAYMENT.btn.gift' | translate }}</ion-text>
      <!-- <ion-button></ion-button> -->
    </ion-item>
    
  </ion-card>

  <ion-card class="ion-padding" (click)="setupLater()" *ngIf="!disableSetupLaterBtn">
    <ion-item class="ion-no-padding" lines="none">
      <ion-icon class="icon-large" slot="start" src="./assets/wedding/icon/payment/setting.svg"></ion-icon>
      <ion-text>{{ 'PAYMENT.btn.later' | translate }}</ion-text>
      <!-- <ion-button></ion-button> -->
    </ion-item>
  </ion-card>
</ion-content>